import axiosInstance from './axiosInstance';

const TPV_API_URL = '/tpv';

const tpvService = {
  async get(idempresa, posto) {
    try {
      const response = await axiosInstance.get(`${TPV_API_URL}/get.php?idempresa=${idempresa}&posto=${posto}`);
      return response.data !== "NOK" ? response.data : [];
    } catch (error) {
      console.error('Erro ao obter TPVs:', error);
      return [];
    }
  }
};

export default tpvService;
